<lib-dialog [title]="product?.name" (closeButtonClick)="closeDialog()">
  <div body>
    <h2>{{ 'product-happy-hour-dialog.text.happy-hour' | translate }}</h2>
    <h1 class="highlight-text">{{ discountText }}</h1>

    <div>
      {{ happyHourWeekdays }}
    </div>

    <div>
      {{ getTimeToDisplay(product?.happyHours?.fromHour) }} -
      {{ getTimeToDisplay(product?.happyHours?.toHour) }}
    </div>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'product-happy-hour-dialog.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>
